import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@mui/material';
import { BarChart, ChartsLegend } from '@mui/x-charts';

import '../ApplicantsNewDashboard.css';
import CardTitle from '../CardTitle/CardTitle';

const LinearProgressWidgetCard = ({
  card,
  showToggle = false,
  switchChange,
  editMode,
  handleSaveCardTitle,
  handleDeleteCard,
  handleEditCard,
  handleCardTitle,
  cardTitleChangeId,
}) => {
  const data = card?.data || [];
  const series = card?.series || [];

  return (
    <Card className="dashboard__card">
      <CardTitle
        card={card}
        editMode={editMode}
        handleSaveCardTitle={handleSaveCardTitle}
        handleDeleteCard={handleDeleteCard}
        handleEditCard={handleEditCard}
        handleCardTitle={handleCardTitle}
        cardTitleChangeId={cardTitleChangeId}
      />
      <CardContent style={{ position: 'relative' }}>
        {data.length > 0 ? (
          <div>
            <BarChart
              dataset={data}
              yAxis={[{ scaleType: 'band', dataKey: 'title' }]}
              margin={{ left: 100, bottom: 80, right: 20, top: 20 }}
              grid={{ horizontal: true }}
              series={series}
              layout="horizontal"
              // width={500}
              height={data.length === 1 ? 140 : data.length * 95}
              slots={{ legend: () => null }}
              // barLabel= {"value"}
            />
            {/* Legend outside */}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: 10,
                marginTop: -15,
              }}
            >
              {series.map((s) => (
                //                ...s,
                // label: { position: "inside", formatter: (v) => v > 0 ? v : "" }}
                <div
                  key={s.dataKey}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <div
                    style={{
                      width: 14,
                      height: 14,
                      background: s.color,
                      marginRight: 6,
                      borderRadius: 3,
                    }}
                  />
                  <span style={{ fontSize: 12 }}>{s.label}</span>
                </div>
              ))}
            </div>
            {/* <div>TESTTT</div> */}
          </div>
        ) : (
          <div className="dashboard__card-no-data-container">
            No data available
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(LinearProgressWidgetCard);
